import { render } from "./StatView.vue?vue&type=template&id=3c4f352e&scoped=true"
import script from "./StatView.vue?vue&type=script&lang=js"
export * from "./StatView.vue?vue&type=script&lang=js"

import "./StatView.vue?vue&type=style&index=0&id=3c4f352e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c4f352e"]])

export default __exports__